import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=5b2dbdfa&"
import script from "./JobDetail.vue?vue&type=script&lang=js&"
export * from "./JobDetail.vue?vue&type=script&lang=js&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports